var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-box",style:(this.preData.show ? `zoom: ${_vm.size}; width: 355px; height: 178px` : ` width: 231px; height: 190px`)},[_c('chart-block',{ref:"chart2",staticClass:"chart2",style:(this.preData.show ? `width: 355px; height: 178px` : ` width: 231px; height: 190px`)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }